import { Network } from '@capacitor/network';
import mitt from 'mitt';

// plugin's methods
const methods = [
	'getStatus',
];

// plugin's listeners
const emitter = mitt();
const events = [
	'networkStatusChange',
];

Network.removeAllListeners();

events.forEach(event => {
	Network.addListener(event, data => {
		emitter.emit(event, data);
	});
});

export function useNativeNetwork () {
	// methods
	const api = methods.reduce((api, name) => {
		api[name] = Network[name];
		return api;
	}, {});

	// custom add listener
	function addListener (event, callback) {
		emitter.on(event, callback);
		return () => emitter.off(event, callback);
	}

	// custom remove all listeners
	function removeAllListeners () {
		emitter.all.clear();
	}

	return {
		...api,
		addListener,
		removeAllListeners,
	};
};
